import { render, staticRenderFns } from "./cal-dynamic-landing-page.vue?vue&type=template&id=74b31a28"
import script from "./cal-dynamic-landing-page.vue?vue&type=script&lang=js"
export * from "./cal-dynamic-landing-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CalDynamicLandingProducts: require('/app/components/cal-dynamic-landing-products.vue').default,CalMainCarousel: require('/app/components/cal-main-carousel.vue').default,CalCardSection: require('/app/components/cal-card-section.vue').default,CalCenterHeading: require('/app/components/cal-center-heading.vue').default,CalHFeatureSection: require('/app/components/cal-h-feature-section.vue').default,CalMomentSection: require('/app/components/cal-moment-section.vue').default,CalPara: require('/app/components/cal-para.vue').default,CalMainCarousel: require('/app/components/cal-main-carousel.vue').default,CalVFeatureSection: require('/app/components/cal-v-feature-section.vue').default,CalRewardsProgramSection: require('/app/components/cal-rewards-program-section.vue').default})
